import { THEME_TYPE } from "../Types/CommonTypes";

export const DayTheme: THEME_TYPE = {
  type: "light",
  colors: {
    primary: "#F1684C",
    accent: "#EC5195",
    background: "#FAF9F4",
    surface: "#ffffff",
    error: "#e63946",
    text: "#000000",
    onSurface: "#000000",
    // disabled: '#adb5bd',
    disabled: "#EEEEEE",
    placeholder: "#93959f",
    // placeholder:"#EEEEEE",
    backdrop: "rgba(0,0,0,0.5)",
    notification: "#ff006e",
    white: "#ffffff",
    black: "#000000",
    success: "#51C084",
    warning: "#FFBF00",
    transparent: "transparent",
    adaptivePrimary: "#F1684C",
    divider: "rgba(0,0,0,0.26)",
    dark: "#27292B",
  },
  fonts: {
    thin: {
      fontFamily: "Raleway-Thin",
      fontWeight: "100",
    },
    light: {
      fontFamily: "Raleway-Light",
      fontWeight: "300",
    },
    regular: {
      fontFamily: "Raleway-Regular",
      fontWeight: "400",
    },
    medium: {
      fontFamily: "Raleway-Medium",
      fontWeight: "500",
    },
    semiBold: {
      fontFamily: "Raleway-SemiBold",
      fontWeight: "600",
    },
    bold: {
      fontFamily: "Raleway-Bold",
      fontWeight: "700",
    },
    black: {
      fontFamily: "Raleway-Black",
      fontWeight: "900",
    },
    extraBold: {
      fontFamily: "Raleway-ExtraBold",
      fontWeight: "900",
    },
  },
  gradientColors: {
    gradientPrimary: ["#51C084", "#FFBF00"],
    gradientAccent: ["#51C084", "#FFBF00"],
    gradientBackground: ["#51C084", "#FFBF00"],
    gradientHighlight: ["#51C084", "#FFBF00"],
    gradientFestive: ["#51C084", "#FFBF00"],
    gradientSale: ["#51C084", "#FFBF00"],
    gradientBorder: ["#51C084", "#FFBF00"],
    gradientIcon: ["#51C084", "#FFBF00"],
    gradientSubtle: ["#51C084", "#FFBF00"],
    gradientOverlay: ["#51C084", "#FFBF00"],
  },
};

export const NightTheme: THEME_TYPE = {
  type: "dark",
  colors: {
    primary: "#F1684C",
    accent: "green",
    background: "#121212",
    surface: "#121212",
    error: "#CF6679",
    onSurface: "#FFFFFF",
    text: "#FFFFFF",
    disabled: "rgba(255,255,255,0.38)",
    placeholder: "rgba(255,255,255,0.54)",
    backdrop: "rgba(255,255,255,0.5)",
    notification: "#f8bbd0",
    white: "#ffffff",
    black: "#000000",
    success: "#25a820",
    warning: "#FFBF00",
    transparent: "transparent",
    adaptivePrimary: "#121212",
    divider: "rgba(255,255,255,0.38)",
    dark: "#27292B",
  },
  fonts: {
    thin: {
      fontFamily: "Raleway-Thin",
      fontWeight: "100",
    },
    light: {
      fontFamily: "Raleway-Light",
      fontWeight: "300",
    },
    regular: {
      fontFamily: "Raleway-Regular",
      fontWeight: "400",
    },
    medium: {
      fontFamily: "Raleway-Medium",
      fontWeight: "500",
    },
    semiBold: {
      fontFamily: "Raleway-SemiBold",
      fontWeight: "600",
    },
    bold: {
      fontFamily: "Raleway-Bold",
      fontWeight: "700",
    },
    black: {
      fontFamily: "Raleway-Black",
      fontWeight: "900",
    },
    extraBold: {
      fontFamily: "Raleway-ExtraBold",
      fontWeight: "900",
    },
  },
  gradientColors: {
    gradientPrimary: ["#51C084", "#FFBF00"],
    gradientAccent: ["#51C084", "#FFBF00"],
    gradientBackground: ["#51C084", "#FFBF00"],
    gradientHighlight: ["#51C084", "#FFBF00"],
    gradientFestive: ["#51C084", "#FFBF00"],
    gradientSale: ["#51C084", "#FFBF00"],
    gradientBorder: ["#51C084", "#FFBF00"],
    gradientIcon: ["#51C084", "#FFBF00"],
    gradientSubtle: ["#51C084", "#FFBF00"],
    gradientOverlay: ["#51C084", "#FFBF00"],
  },
};
